import axios from "axios";

const Axios = axios.create({
  baseURL: process.env.REACT_APP_API_KEY,
  timeout: 10000,
  withCredentials: true,

  headers: {
    "Content-Type": "application/json",
  },
});

export default Axios;
